// Shzoom Theme - Based on mobile app ShzoomTheme.ts
export const ShzoomTheme = {
  // Primary Colors - Shzoom Orange
  'color-primary-100': '#FFF2CC',
  'color-primary-200': '#FFE299',
  'color-primary-300': '#FFCE67',
  'color-primary-400': '#FFBA41',
  'color-primary-500': '#FF9902', // Main Shzoom Orange
  'color-primary-600': '#DB7A01',
  'color-primary-700': '#B75F01',
  'color-primary-800': '#934600',
  'color-primary-900': '#7A3500',

  // Success Colors
  'color-success-100': '#C8F7CE',
  'color-success-200': '#95F0A8',
  'color-success-300': '#5BD480',
  'color-success-400': '#31A962',
  'color-success-500': '#06703C',
  'color-success-600': '#04603C',
  'color-success-700': '#03503A',
  'color-success-800': '#014034',
  'color-success-900': '#013530',

  // Info Colors
  'color-info-100': '#CCEEFD',
  'color-info-200': '#9BD8FC',
  'color-info-300': '#68BCF8',
  'color-info-400': '#429FF2',
  'color-info-500': '#0875EA',
  'color-info-600': '#055AC9',
  'color-info-700': '#0443A8',
  'color-info-800': '#022F87',
  'color-info-900': '#012170',

  // Warning Colors
  'color-warning-100': '#FEF8D5',
  'color-warning-200': '#FDF0AC',
  'color-warning-300': '#F9E382',
  'color-warning-400': '#F3D562',
  'color-warning-500': '#EBC031',
  'color-warning-600': '#CA9F23',
  'color-warning-700': '#A98018',
  'color-warning-800': '#88630F',
  'color-warning-900': '#704E09',

  // Danger Colors
  'color-danger-100': '#FEE9D8',
  'color-danger-200': '#FDCDB2',
  'color-danger-300': '#FBAB8C',
  'color-danger-400': '#F8896E',
  'color-danger-500': '#F45540',
  'color-danger-600': '#D1342E',
  'color-danger-700': '#AF2026',
  'color-danger-800': '#8D1423',
  'color-danger-900': '#750C21',

  // Gray Scale
  'color-gray-100': '#f8f9fa',
  'color-gray-200': '#e9ecef',
  'color-gray-300': '#dee2e6',
  'color-gray-400': '#ced4da',
  'color-gray-500': '#adb5bd',
  'color-gray-600': '#6c757d',
  'color-gray-700': '#495057',
  'color-gray-800': '#343a40',
  'color-gray-900': '#212529',

  // Special Colors
  'background-color': '#FAF8F6', // Shzoom cream background
  'photo-background-color': '#F7F9FC',
  'border-color': 'grey',
};

// CSS Custom Properties for web
export const ShzoomCSSVars = {
  '--shzoom-primary': '#FF9902',
  '--shzoom-primary-light': '#FFE299',
  '--shzoom-primary-dark': '#DB7A01',
  '--shzoom-background': '#FAF8F6',
  '--shzoom-surface': '#FFFFFF',
  '--shzoom-text': '#212529',
  '--shzoom-text-secondary': '#6c757d',
  '--shzoom-border': '#dee2e6',
  '--shzoom-success': '#06703C',
  '--shzoom-warning': '#EBC031',
  '--shzoom-danger': '#F45540',
  '--shzoom-info': '#0875EA',
};

// Ant Design Theme Token Overrides
export const ShzoomAntTheme = {
  token: {
    colorPrimary: '#FF9902',
    colorBgBase: '#FAF8F6',
    borderRadius: 8,
    colorText: '#212529',
    colorTextSecondary: '#6c757d',
    colorBorder: '#dee2e6',
    colorSuccess: '#06703C',
    colorWarning: '#EBC031',
    colorError: '#F45540',
    colorInfo: '#0875EA',
    fontFamily: '"Open Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  },
  components: {
    Button: {
      primaryShadow: 'none',
      colorPrimary: '#FF9902',
      colorPrimaryHover: '#FFE299',
      colorPrimaryActive: '#DB7A01',
    },
    Input: {
      colorBorder: '#dee2e6',
      borderRadius: 8,
    },
    Card: {
      colorBgContainer: '#FFFFFF',
      borderRadiusLG: 12,
    },
    Layout: {
      bodyBg: '#FAF8F6',
      headerBg: '#FF9902',
    },
  },
};

export default ShzoomTheme;